import PropTypes from "prop-types";
import { getValidationStatusLabel,getValidationStatusClass,getValidationStatusIcon } from "./service/utils/validationStatus";

const ValidationStatusBadge = ({ status, showIcon = true }) => {
  const label = getValidationStatusLabel(status);
  const statusClass = getValidationStatusClass(status);
  const icon = getValidationStatusIcon(status);

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${statusClass}`}>
      {showIcon && <span className="mr-1">{icon}</span>}
      {label}
    </span>
  );
};

ValidationStatusBadge.propTypes = {
  status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showIcon: PropTypes.bool,
};

export default ValidationStatusBadge;